import React from "react";
import { Box, Container } from "@chakra-ui/react";
import SkillsSection from "../atoms/SkillsSection";

const Skills = () => {
  return (
    <Box
      h="100vh"
      minH="100vh"
      w="full"
      p={30}
      id="skills"
      className="scroll-section"
      scrollSnapAlign="start"
      background={"linear-gradient( #F9F0DF, #F9F0DF, #F9F0DF)"}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Container maxW="1200px" overflow={"visible"}>
        {/* <Heading as="h2" size="2xl" my="16" textAlign="center" color="white">
          Skills
        </Heading> */}
        <SkillsSection />
      </Container>
    </Box>
  );
};

export default Skills;
